import React from "react";
import { baseUrl } from "../../axiosStrapi";
import { FaArrowRight } from "react-icons/fa6";

const BlogContainer = ({ data }) => {
  return (
    <div className="grid w-full relative sm:grid-cols-2 lg:grid-cols-3 gap-10">
      {data?.map((post, index) => (
        <div
          key={index}
          style={{
            borderRadius: "10px",
            overflow: "hidden",
            backgroundColor: "#fff",
            textAlign: "left",
            boxShadow: "0px 0px 10px 0px #0000001F",
          }}
        >
          <img
            src={`${post?.headerImages?.desktopHeaderImage?.url}`}
            alt={post.title}
            style={{ width: "100%", height: "200px", objectFit: "cover" }}
          />
          <div style={{ padding: "15px" }}>
            <h3
              className="font-bold"
              style={{
                fontSize: "18px",
                color: "#333",
                margin: "0 0 10px 0",
              }}
            >
              {post.title}
            </h3>
            {post.description && (
              <p
                className="font-xl"
                style={{
                  color: "#666",
                  margin: "0 0 15px 0",
                }}
              >
                {`${post.description?.substr(0, 90)}...`}
              </p>
            )}

            <a
              className="text-xl"
              href={`/blogDetails/${post?.documentId}?${post?.title?.replaceAll(" ","-")}`}
              style={{
                color: "#D31C4F",
                textDecoration: "none",
                fontWeight: "bold",
                cursor: "pointer",
              }}
            >
              Read More <FaArrowRight className="inline" />
            </a>
          </div>
        </div>
      ))}
    </div>
  );
};

export default BlogContainer;
